import React from "react";
import {
  FaBalanceScale,
  FaUserCheck,
  FaBan,
  FaGavel,
  FaExclamationTriangle,
  FaInfoCircle,
} from "react-icons/fa";
import { FiHome } from "react-icons/fi";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="w-full font-nunito bg-gradient-to-b from-gray-50 to-white text-gray-800 px-4 py-10 sm:px-6 lg:px-16">
      {/* Back to Home Button */}
      <div className="flex justify-start  mb-6">
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-md hover:bg-pink-50 transition-colors duration-200"
          >
            <FiHome className="text-pink-500" />
            <span className="text-purple-700 font-medium">Back to Home</span>
          </Link>
        </div>
      <div className="w-full max-w-8xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-cormorant font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-[#9ea3f5] to-[#ccdcfd]">
            Terms of Service
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Effective Date:{" "}
            {new Date().toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
        </div>

        <div className="space-y-10 w-full max-w-6xl mx-auto">
          {/* Section 1 */}
          <section className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center mb-4">
              <FaBalanceScale className="text-[#9ea3f5] text-2xl mr-3" />
              <h2 className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#bbbefe] to-[#9ea3f5]">
                1. Acceptance of Terms
              </h2>
            </div>
            <div className="space-y-4 text-gray-700">
              <p>
                By accessing or using the services provided by FlowHearts.com ("we," "us," or "our"), you agree to be bound by these
                Terms of Service ("Terms"). If you do not agree to these Terms,
                you may not use our services.
              </p>
              <p>
                These Terms apply to all visitors, users, and others who access
                or use our website, mobile application, and related services
                (collectively, the "Service").
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center mb-4">
              <FaUserCheck className="text-[#e8bffb] text-2xl mr-3" />
              <h2 className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#e8bffb] to-[#d099e2]">
                2. User Responsibilities
              </h2>
            </div>
            <div className="space-y-4 text-gray-700">
              <p>When using our Service, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate and complete registration information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Use the Service only for lawful purposes</li>
                <li>Not engage in any activity that interferes with the Service</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
              <p>
                You are solely responsible for all activities that occur under
                your account and for keeping your password secure.
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center mb-4">
              <FaBan className="text-[#ccdcfd] text-2xl mr-3" />
              <h2 className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#ccdcfd] to-[#9ea3f5]">
                3. Prohibited Conduct
              </h2>
            </div>
            <div className="space-y-4 text-gray-700">
              <p>You may not use our Service to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Violate any laws or infringe on others' rights</li>
                <li>Distribute viruses or malicious code</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Harass, abuse, or harm others</li>
                <li>Post false or misleading information</li>
                <li>Engage in any fraudulent activity</li>
              </ul>
              <p>
                We reserve the right to investigate and take appropriate legal
                action against anyone who violates these provisions.
              </p>
            </div>
          </section>

          {/* Section 4 */}
          <section className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center mb-4">
              <FaGavel className="text-[#d099e2] text-2xl mr-3" />
              <h2 className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#d099e2] to-[#f2a5e8]">
                4. Intellectual Property
              </h2>
            </div>
            <div className="space-y-4 text-gray-700">
              <p>
                The Service and its original content, features, and
                functionality are owned by FlowHearts.com and are protected
                by international copyright, trademark, patent, trade secret, and
                other intellectual property or proprietary rights laws.
              </p>
              <p>
                You may not modify, reproduce, distribute, create derivative
                works of, publicly display, or in any way exploit any of the
                content, software, or materials available on the Service without
                our express written permission.
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center mb-4">
              <FaExclamationTriangle className="text-[#bbbefe] text-2xl mr-3" />
              <h2 className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#bbbefe] to-[#ccdcfd]">
                5. Disclaimers & Limitations
              </h2>
            </div>
            <div className="space-y-4 text-gray-700">
              <p>
                <strong>Medical Disclaimer:</strong> Our Service provides health
                information for educational purposes only and is not a
                substitute for professional medical advice, diagnosis, or
                treatment.
              </p>
              <p>
                <strong>Service Availability:</strong> We do not guarantee that
                the Service will be uninterrupted or error-free. We may modify,
                suspend, or discontinue any aspect of the Service at any time.
              </p>
              <p>
                <strong>Limitation of Liability:</strong> To the maximum extent
                permitted by law, we shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages
                resulting from your use of the Service.
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center mb-4">
              <FaInfoCircle className="text-[#f2a5e8] text-2xl mr-3" />
              <h2 className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#f2a5e8] to-[#d099e2]">
                6. General Provisions
              </h2>
            </div>
            <div className="space-y-4 text-gray-700">
              <p>
                <strong>Governing Law:</strong> These Terms shall be governed by
                the laws of our country without regard to its conflict
                of law provisions.
              </p>
              <p>
                <strong>Changes to Terms:</strong> We may revise these Terms at
                any time. The most current version will always be posted on our
                website. Continued use after changes constitutes acceptance.
              </p>
              <p>
                <strong>Termination:</strong> We may terminate or suspend your
                account immediately, without prior notice, for any violation of
                these Terms.
              </p>
              <p>
                <strong>Contact:</strong> For questions about these Terms,
                please contact us at flowheartshelp@gmail.com.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
